export function safeReturnUrl(raw: string | null): string | null {
  if (
    !raw ||
    !raw.startsWith("/") ||
    raw.startsWith("//") ||
    raw.includes("\\")
  ) {
    return null;
  }
  try {
    const url = new URL(raw, window.location.origin);
    const decodedPath = decodeURIComponent(url.pathname);
    if (
      url.origin !== window.location.origin ||
      decodedPath.startsWith("//") ||
      decodedPath.includes("\\") ||
      decodedPath.replace(/\/+$/, "").toLowerCase() === "/login"
    )
      return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function loginUrl(returnUrl: string): string {
  const safe = safeReturnUrl(returnUrl);
  return safe ? `/login?${new URLSearchParams({ returnUrl: safe })}` : "/login";
}

export function currentPageReturnUrl(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
